import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "inputRef", "onKeyDown", "aria-describedby", "placeholder"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { textInputStyle, textInputProps, textInputReset } from './textInputStyle';
import { useFormFieldContext } from 'components/FormField';
import { jsx as _jsx } from "react/jsx-runtime";
var shouldForwardProp = function shouldForwardProp(prop) {
  return !textInputProps.includes(prop);
};
export var StyledInput = styled.input.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "TextInput__StyledInput",
  componentId: "sc-11gwy7p-0"
})(["", " &[type='password']::-ms-clear,&[type='password']::-ms-reveal{display:none;}"], textInputStyle);
var TextInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    inputRef = _ref.inputRef,
    onKeyDown = _ref.onKeyDown,
    ariaDescribedBy = _ref['aria-describedby'],
    placeholder = _ref.placeholder,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useFormFieldContext = useFormFieldContext({
      id: otherProps.id,
      required: otherProps.required,
      descriptionIds: ariaDescribedBy
    }),
    id = _useFormFieldContext.id,
    required = _useFormFieldContext.required,
    horizontal = _useFormFieldContext.horizontal,
    descriptionIds = _useFormFieldContext.descriptionIds;
  return /*#__PURE__*/_jsx(StyledInput, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref || inputRef,
    type: type || 'text',
    id: id,
    required: required,
    "aria-describedby": descriptionIds
    // Safari has a [bug](https://bugs.webkit.org/show_bug.cgi?id=142968) where
    // empty input fields do not align correctly with baseline alignment.
    // Adding a "one space" placeholder fixes the issue.
    ,
    placeholder: horizontal ? placeholder || ' ' : placeholder,
    onKeyDown: onKeyDown
  }));
});
TextInput.displayName = 'TextInput';
export { textInputStyle, textInputProps, textInputReset };
export default TextInput;